var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit16(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8333 1.99955C12.0083 1.82445 12.2162 1.68556 12.445 1.5908C12.6738 1.49604 12.919 1.44727 13.1666 1.44727C13.4142 1.44727 13.6594 1.49604 13.8882 1.5908C14.117 1.68556 14.3248 1.82445 14.4999 1.99955C14.675 2.17465 14.8139 2.38252 14.9087 2.61129C15.0034 2.84006 15.0522 3.08526 15.0522 3.33288C15.0522 3.58051 15.0034 3.8257 14.9087 4.05448C14.8139 4.28325 14.675 4.49112 14.4999 4.66622L5.49992 13.6662L1.83325 14.6662L2.83325 10.9995L11.8333 1.99955Z",
    stroke: "#2E1A47",
    strokeOpacity: 0.5,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit16);
export default __webpack_public_path__ + "static/media/edit-16.c34ff5e703ea6ea7b2778606a41419b0.svg";
export { ForwardRef as ReactComponent };